import { supabase } from '../lib/supabase'

/**
 * Insert a row into the audit_log table.
 * Fire-and-forget — errors are logged to console but not thrown.
 *
 * @param {object} opts
 * @param {object} opts.user     - Supabase auth user object
 * @param {object} opts.profile  - Profile row from public.profiles
 * @param {string} opts.action   - Short verb, e.g. 'approve_receipt', 'create_camp'
 * @param {string} [opts.entity] - Table/entity name, e.g. 'registrations', 'camps'
 * @param {string} [opts.entity_id] - Primary key of the affected row
 * @param {object} [opts.details]   - Any extra context (plain object → stored as jsonb)
 */
export async function logAction({ user, profile, action, entity, entity_id, details }) {
  try {
    await supabase.from('audit_log').insert({
      user_id:    user?.id ?? null,
      user_email: user?.email ?? null,
      user_role:  profile?.role ?? null,
      action,
      entity:     entity    ?? null,
      entity_id:  entity_id ? String(entity_id) : null,
      details:    details   ?? null,
    })
  } catch (err) {
    console.error('[auditLog] failed to write audit log:', err)
  }
}
